import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useEffect,
} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { analyticsTrackEvent } from "../../../_utils/common";
import { ErrorMessage, Form, Formik } from "formik";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Divider,
  Button,
  ModalCloseButton,
  ButtonGroup,
  Input,
  InputGroup,
} from "@chakra-ui/react";
import { handleHTTPError } from "../../../_actions/errorHandlerActions";
import axios from "axios";
import { startShopifyOAuth } from "apps/simplified-web/src/_components/oauth/utils";

export const ShopifyConnectApp = forwardRef((props, ref) => {
  const { t } = useTranslation(["planner", "common"]);
  const signal = axios.CancelToken.source();
  const {  auth } = props;

  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    setOpen,
  }));

  const [storeURL, setStoreURL] = useState(null);
  const [accountSubmitting, setAccountSubmitting] = useState(false);

  const handleModalClose = () => {
    setOpen(false);
    setAccountSubmitting(false);
    setStoreURL(null);
  };

  useEffect(() => {
    if (storeURL) {
      startShopifyOAuth(storeURL)

      // window.open(url, "_self");
      analyticsTrackEvent("ShopifyConnected", {
        User_Conn_To_Shopify: auth.payload?.user?.email,
      });
    }

    return () => {
      // Clean up!
    };
  }, [storeURL]);

  return (
    <Modal size="lg" isOpen={open} onClose={handleModalClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <Formik
          initialValues={{ name: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.name) {
              errors.name = t("connect_shopify.valid_name");
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            setStoreURL(values["name"]);
            setSubmitting(false);
          }}
        >
          {({ isSubmitting, handleChange, handleBlur, values }) => (
            <Form>
              <ModalHeader>
                {isSubmitting
                  ? t("connect_shopify.connecting_store")
                  : t("connect_shopify.submit")}
              </ModalHeader>
              <ModalCloseButton />
              <Divider my="1" />
              <ModalBody>
                <div>
                  {isSubmitting
                    ? t("connect_shopify.connecting")
                    : t("connect_shopify.enter_username")}
                </div>

                <InputGroup mt="3">
                  <Input
                    type="text"
                    name="name"
                    placeholder={t("connect_shopify.placeholder")}
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </InputGroup>
                <ErrorMessage name="name" component="div" className="error" />
              </ModalBody>
              <Divider my="1" />

              <ModalFooter>
                <ButtonGroup>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleModalClose();
                    }}
                    variant="outline"
                    disabled={isSubmitting}
                  >
                    {t("cancel", { ns: "common" })}
                  </Button>

                  <Button
                    type="submit"
                    variant="solid"
                    disabled={
                      isSubmitting  || accountSubmitting
                    }
                    isLoading={
                      isSubmitting || accountSubmitting
                    }
                    loadingText="Authorizing"
                  >
                    {t("connect", { ns: "common" })}
                  </Button>
                </ButtonGroup>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );
});

ShopifyConnectApp.propTypes = {
  onSuccess: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

ShopifyConnectApp.defaultProps = {
  onSuccess: () => {},
};

export default connect(mapStateToProps, { handleHTTPError }, null, {
  forwardRef: true,
})(ShopifyConnectApp);
